export default __webpack_public_path__ + "static/media/nv6.57f36b9a.PNG";